const initAdsAutoplay = (adTagUrl, onEnded, pauseHandler, muted = false, cookieEnabled = true) => {
  const videoContent = document.getElementById('video-player');
  const adContainer = document.getElementById("adContainer");

  if (null === adContainer) {
    console.error('The ad container was not initialized.');
    return;
  }

  const adContainerDimensions = adContainer.getBoundingClientRect();

  let adsLoader = null;
  let adDisplayContainer = null;
  let adsManager = null;
  let adsInitialized = false;
  let autoplayAllowed = true;
  let autoplayRequiresMuted = true;

  function initAutoplay() {
    setUpIMA();
    checkAutoplaySupport();
  }

  function setUpIMA() {
    adDisplayContainer = new window.google.ima.AdDisplayContainer(
      adContainer,
      videoContent
    );
    adsLoader = new window.google.ima.AdsLoader(adDisplayContainer);
    adsLoader.getSettings().setCookiesEnabled(cookieEnabled);
    adsLoader.addEventListener(
      window.google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
      onAdsManagerLoaded,
      false
    );
    adsLoader.addEventListener(
      window.google.ima.AdErrorEvent.Type.AD_ERROR,
      onAdError,
      false
    );
  }

  function checkAutoplaySupport() {
    if (muted) {
      checkMutedAutoplaySupport();
    } else {
      onAutoplayWithSoundSuccess()
    }
  }

  function onAutoplayWithSoundSuccess() {
    autoplayAllowed = true;
    videoContent.volume = 100;
    videoContent.muted = false;
    autoplayRequiresMuted = false;
    autoplayChecksResolved();
  }

  function checkMutedAutoplaySupport() {
    videoContent.volume = 0;
    videoContent.muted = true;
    onMutedAutoplaySuccess()
  }

  function onMutedAutoplaySuccess() {
    autoplayAllowed = true;
    autoplayRequiresMuted = true;
    autoplayChecksResolved();
  }

  function autoplayChecksResolved() {
    const adsRequest = new window.google.ima.AdsRequest();
    adsRequest.adTagUrl = adTagUrl.replace(/%/g, '');
    adsRequest.linearAdSlotWidth = adContainerDimensions.width;
    adsRequest.linearAdSlotHeight = adContainerDimensions.height;
    adsRequest.nonLinearAdSlotWidth = adContainerDimensions.width;
    adsRequest.nonLinearAdSlotHeight = adContainerDimensions.height;

    adsRequest.setAdWillAutoPlay(autoplayAllowed);
    adsRequest.setAdWillPlayMuted(autoplayRequiresMuted);

    adsLoader.requestAds(adsRequest);
  }

  function playAds() {
    try {
      if (!adsInitialized) {
        adDisplayContainer.initialize();
        adsInitialized = true;
      }
      adsManager.init(
        adContainerDimensions.width,
        adContainerDimensions.height,
        window.google.ima.ViewMode.NORMAL
      );
      adsManager.start();

    } catch (adError) {
      console.error("AD_ERROR", adError);
    }
  }

  function onAdsManagerLoaded(adsManagerLoadedEvent) {
    const adsRenderingSettings = new window.google.ima.AdsRenderingSettings();
    adsRenderingSettings.restoreCustomPlaybackStateOnAdBreakComplete = true;

    adsManager = adsManagerLoadedEvent.getAdsManager(
      videoContent,
      adsRenderingSettings
    );

    const adVolume = autoplayAllowed && autoplayRequiresMuted ? 0 : 1;
    adsManager.setVolume(adVolume);

    adsManager.addEventListener(
      window.google.ima.AdErrorEvent.Type.AD_ERROR,
      onAdError
    );
    adsLoader.addEventListener(
      window.google.ima.AdErrorEvent.Type.AD_ERROR,
      onAdError
    );
    adsManager.addEventListener(
      window.google.ima.AdEvent.Type.ALL_ADS_COMPLETED,
      onAdEvent
    );
    adsManager.addEventListener(
      window.google.ima.AdEvent.Type.STARTED,
      onAdStarted
    );
    adsManager.addEventListener(
      window.google.ima.AdEvent.Type.COMPLETE,
      onAdComplete
    );
    adsManager.addEventListener(
      window.google.ima.AdEvent.Type.LOG,
      onLogError
    );
    adsManager.addEventListener(
      window.google.ima.AdEvent.Type.SKIPPED,
      onAdSkip
    );

    if (autoplayAllowed) {
      playAds();
    }
  }

  function onLogError() {
    onEnded(adContainer);
  }

  function onAdStarted() {
    adContainer.classList.add("adContainer--visible");
    pauseHandler();
  }

  function onAdComplete() {
    onEnded(adContainer);
  }

  function onAdSkip() {
    onEnded(adContainer);
  }

  function onAdEvent(adEvent) {
    switch (adEvent.type) {
      case window.google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
        adsManager.destroy();
        break;
    }
  }

  function onAdError() {
    onEnded(adContainer);

    if (adsManager) {
      adsManager.destroy();
    }
  }

  if (window.google !== undefined) {
    initAutoplay();
  }
}

export default initAdsAutoplay;